import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/details-v4/ListingDetailsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/details-v4/WorkspaceDetailsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/location-pages/CityHeroMap.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/location-pages/CitySearch.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/location-pages/LocationPages.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/shared/ListingCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/tracking/WorkspaceDiscoveryTracking.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/store/store.ts");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
